<template>
  <div class="dashboard-block">
    <h4
      v-if="title && type === 'personalInfo'"
      class="dashboard-block__title"
    >
      {{ title }}
    </h4>
    <slot name="content" />
    <div v-if="type === 'metric'" class="dashboard-block__wrapper_metric">
      <div class="wrapper__icon">
        <i class="fa fa-5x" :class="metricIconCss" />
      </div>
      <div class="wrapper__info">
        <span class="info__title">{{ title }}</span>
        <span class="info__value_metric">
          {{ metric.value }}
        </span>
        <slot name="metric-button" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String | null,
      default: null,
    },
    type: {
      type: String,
      default: 'personalInfo',
      validator(value) {
        const possibleValues = ['personalInfo', 'metric'];
        return !!possibleValues.includes(value);
      },
    },
    metric: {
      type: Object,
      default() {
        return {
          icon: '',
          value: '',
        };
      },
    },
  },
  computed: {
    metricIconCss() {
      if (this.metric.icon !== '') {
        return [`fa-${this.metric.icon}`];
      }
    },
  },
};
</script>

<style scoped>
.dashboard-block {
  background-color: #fff;
  border-radius: 6px;
  padding: 20px;
  -webkit-box-shadow: 2px 8px 16px 0px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 2px 8px 16px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 2px 8px 16px 0px rgba(0, 0, 0, 0.3);
}
.dashboard-block h1, h2, h3, h4, h5, span {
  padding: 0;
  margin: 0;
}

.dashboard-block__title {
  font-weight: 600;
  font-size: 1.25em;
}

.dashboard-block__title:hover,
.dashboard-block__title:focus {
  cursor: default;
}

.dashboard-block__wrapper_metric {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding: 2em 0;
}

.dashboard-block__wrapper_metric .wrapper__info {
  line-height: 1.2;
  padding-left: 2em;
  height: 100%;
  display: inline-flex;
  flex-direction: column;
  cursor: default;
}

.dashboard-block__wrapper_metric .wrapper__info .info__title {
  font-size: 1.2em;
}

.info__value_metric {
  font-size: 2.2em;
  font-weight: 600;
}

.dashboard-block__wrapper_metric .wrapper__icon .fa,
.info__value_metric {
  color: #08c;
}

@media (max-width: 767px) {
  .dashboard-block__wrapper_metric {
    width: 100%;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/ui/DashboardBlock.vue